import React, { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2';

const EditUnits = ({ show, onClose, unitData, onUnitUpdated }) => { 
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [unitCatOptions, setUnitCatOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [score, setScore] = useState('');
  const [score_name, setScoreName] = useState('');
  const [description, setDescription] = useState('');
  // const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   // Fetch categories using same key as AddUnits: unitcategory_id
  //   axios.get(`${baseURL}/unitcategory/category/active`)
  //     .then(res => {
  //       const options = res.data.data.map(cat => ({
  //         value: cat.unitcategory_id,  // Use unitcategory_id, same as AddUnits
  //         label: cat.unitcategory_name
  //       }));
  //       setUnitCatOptions(options);
  //     })
  //     .catch(err => {
  //       console.error('Failed to fetch unit categories:', err);
  //       Swal.fire('Error', 'Failed to load unit categories.', 'error');
  //     });
  // }, []);

  // Populate form when unitData and categories loaded
  useEffect(() => {
    if (unitData && unitCatOptions.length > 0) {
      setScore(unitData.score || '');
      setScoreName(unitData.score_name || '');
      setDescription(unitData.description || '');

      // unitData.unit_category is array of category IDs (unitcategory_id)
      // const selectedCats = Array.isArray(unitData.unit_category) ? unitData.unit_category : [];

      // Filter options to match selectedCats by value
      // const selectedOpts = unitCatOptions.filter(opt => selectedCats.includes(opt.value));
      // setSelectedOption(selectedOpts);
    }
  }, [unitData, unitCatOptions]);

  // const handleCategoryChange = selected => {
  //   setSelectedOption(selected || []);
  // };

  const handleUpdate = async () => {
    // const unit_category_snos = selectedOption.map(opt => opt.value);

    // if (!unitName.trim() || unit_category_snos.length === 0) {
    //   Swal.fire('Validation Error', 'Unit name and at least one category are required.', 'warning');
    //   return;
    // }

    // if (!unitData?.sno) {
    //   Swal.fire('Error', 'Invalid unit data', 'error');
    //   return;
    // }

    const payload = {
      score: score.trim(),
      score_name: score_name.trim() || null,
      description: description.trim() || null,
      // unit_category_snos
    };

    try {
      // setLoading(true);
      const res = await axios.post(`${baseURL}/score/${unitData.sno}`, payload);
      Swal.fire('Success', res.data.message || 'Unit updated successfully', 'success');
      if (onUnitUpdated) onUnitUpdated();
      onClose();
    } catch (err) {
      const msg = err.response?.data?.message || 'Something went wrong';
      const errors = err.response?.data?.errors;
      if (errors) {
        const errorList = Object.values(errors).flat().join('<br>');
        Swal.fire('Validation Error', errorList, 'error');
      } else {
        Swal.fire('Error', msg, 'error');
      }
    } finally {
      // setLoading(false);
    }
  };

  if (!unitData || unitCatOptions.length === 0) {
    return (
      <Modal show={show} size="md" onHide={onClose} centered>
        <div className="d-flex justify-content-center align-items-center p-5">
          <Spinner animation="border" variant="primary" />
        </div>
      </Modal>
    );
  }

  return (
    <Modal show={show} size="md" onHide={onClose} centered>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#dcf1dc' }}>
          <h3 className="modal-title">Update Units</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Score<span className="required">*</span></label>
              <input
                type="text"
                className="form-control"
                value={score}
                onChange={e => setScore(e.target.value)}
                placeholder="Enter Unit Name"
              />
            </div>
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Score Name</label>
              <input
                type="text"
                className="form-control"
                value={score_name}
                onChange={e => setScoreName(e.target.value)}
                placeholder="Enter Short Name"
              />
            </div>
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Description</label>
              <textarea
                rows={5}
                className="form-control"
                value={description}
                onChange={e => setDescription(e.target.value)}
                placeholder="Description"
              />
            </div>
          </div>
          <div className="d-flex justify-content-center gap-3 mt-4 mb-4">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={handleUpdate} >
              {/* {loading ? <Spinner size="sm" animation="border" /> : "Update Unit"} */}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditUnits;
